import React from "react";
import { Button as RsuiteButton, ButtonProps } from "rsuite";

import "./index.scss";

const Button = (props: ButtonProps) => {
  return (
    <div className="button-wrapper">
      <RsuiteButton {...props} />
    </div>
  );
};

export default Button;
